// src/utils/timeUtils.js

export const calculateTotalTime = (tasks, timeField) => {
    return tasks.reduce((total, { task }) => total + (task ? task[timeField] : 0), 0);
};

export const getTotalElapsedTime = (currentTime) => {
    const now = currentTime;
    const startOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    return (now - startOfDay) / 1000; // 转换为秒
};

export const getTotalRemainingTime = (currentTime) => {
    const now = currentTime;
    const endOfDay = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1);
    return (endOfDay - now) / 1000; // 转换为秒
};

export const getElapsedPercentage = (totalSecondsInDay, elapsedSeconds) => {
    return (elapsedSeconds / totalSecondsInDay) * 100;
};

export const formatTime = (date) => {
    return date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false });
};

export const formatRemainingTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = Math.floor(seconds % 60);
    return `${hrs.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
};
